<template>
	<el-container style="height: 100vh;" id="poster">
		<el-main>
			<el-row type="flex" class="row-bg" justify="center">
				<!-- <el-col :xl="6" :lg="7">
				  <h2>欢迎来到测试管理平台</h2>
				  <el-image :src="require('@/assets/first.jpg')" style="height: 300px; width: 450px;"></el-image>

				</el-col> -->

				<!-- <el-col :span="1">
				  <el-divider direction="vertical"></el-divider>
				</el-col> -->
				<el-col :xl="16" :lg="17">
					<h2 style="margin-left: 130px;">平台用户登录</h2>
					<el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="100px">
						<el-form-item label="用户账号" prop="username" style="width: 380px;">
							<!-- <el-input id="userinput" ref="userinput" v-model="loginForm.username" @keyup.enter.native="keyConfirm('loginForm', 1, $event)"></el-input> -->
							<el-input id="userinput" ref="userinput" v-model="loginForm.username"></el-input>
						</el-form-item>
						<el-form-item label="登录密码" prop="password" style="width: 380px;">
							<el-input id="pwdinput" ref="pwdinput" v-model="loginForm.password"
									  type="password"></el-input>
						</el-form-item>
						<el-form-item label="验证码" prop="code" style="width: 380px;">
							<el-input id="codeinput" ref="codeinput" v-model="loginForm.code"
									  style="width: 150px; float: left"
									  maxlength="4"></el-input>
							<el-image :src="captchaImg" class="captchaImg" @click="getCaptcha"></el-image>
						</el-form-item>

						<el-form-item>
							<el-button style="width: 300px; height: 45px; margin-left: -35px;" type="primary"
									   @click="submitForm('loginForm')">登录
							</el-button>
							<!-- <el-button @click="resetForm('loginForm')">重置</el-button> -->
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
		</el-main>
	</el-container>
</template>

<script>

import qs from 'qs'

export default {
	name: "Login",
	data() {
		return {
			loginForm: {
				username: '',
				password: '',
				code: '',
				token: ''
			},
			rules: {
				username: [
					{required: true, message: '请输入用户名', trigger: 'blur'}
				],
				password: [
					{required: true, message: '请输入密码', trigger: 'blur'}
				],
				code: [
					{required: true, message: '请输入验证码', trigger: 'blur'}
				],
			},
			captchaImg: null
		};
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$axios.post('/login?' + qs.stringify(this.loginForm)).then(res => {

						console.log(res)

						const jwt = res.headers['authorization']

						this.$store.commit('SET_TOKEN', jwt)
						this.$router.push("/index")
					})

				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		getCaptcha() {
			this.$axios.get('/captcha').then(res => {

				console.log("/captcha")
				console.log(res)

				this.loginForm.token = res.data.data.token
				this.captchaImg = res.data.data.captchaImg
				this.loginForm.code = ''
			})
		},
		keyConfirm(formName, index, e) {
			var keyCode = e.keyCode || e.which || e.charCode;
			this.loginForm = true
			const _this = this
			setTimeout(function () {
				if (keyCode === 13) {
					if (index === 1) {
						_this.$refs["pwdinput"].focus();
					} else if (index === 2) {
						_this.$refs["codeinput"].focus();
					} else if (index === 3) {
						_this.submitForm(formName);
					}
				}
			}, 1)

		}
	},
	created() {
		this.getCaptcha()
		console.log("当前token:" + this.loginForm.token);
	},
	mounted() {
		if (this.loginForm.token == null) {
			console.log("重新获取token:" + this.loginForm.token);
			this.getCaptcha()
		}
	}
}
</script>

<style scoped>

.el-row {
	background-color: #ffffff;
	width: 30%;
	height: 40%;
	display: flex;
	margin-top: 15%;
	margin-left: 50%;
	/*align-items: center;
	text-align: center;*/
	justify-content: center;
}

.el-divider {
	height: 200px;
}

.captchaImg {
	float: left;
	margin-left: 8px;
	border-radius: 4px;
}

#poster {
	background: url("../assets/login-bg.jpg") no-repeat;
	background-position: center;
	height: 100%;
	width: 100%;
	background-size: cover;
	position: fixed;
}

</style>